{
  "testEnvironment": "Testovací prostředí",
  "currency": {
    "czk": "Kč",
    "eur": "€",
    "usd": "$"
  },
  "dashboardSidebarCollapse": {
    "expand": "Rozbalit postranní panel",
    "collapse": "Sbalit postranní panel"
  },
  "dashboardSidebarToggle": {
    "close": "Zavřít postranní panel",
    "open": "Otevřít postranní panel"
  },
  "navigation": {
    "dashboard": "Moje úkoly",
    "quotations": "Nabídkové kalkulace",
    "workflows": "Workflow",
    "clients": "Klienti",
    "users": "Uživatelé",
    "sapImport": "SAP Import",
    "deadLetters": "Nedoručené zprávy",
    "settings": "Nastavení",
    "noAccess": "Přístup odepřen",
    "workflow": "Workflow"
  },
  "sapImport": {
    "title": "SAP Import",
    "description": "Přehled importovaných dat ze SAPu.",
    "table": {
      "fileName": "Název souboru",
      "created": "Vytvořeno",
      "size": "Velikost",
      "actions": "Akce",
      "showing": "Zobrazeno",
      "of": "z",
      "loading": "Načítání...",
      "search": "Hledat podle názvu souboru"
    },
    "actions": {
      "preview": "Náhled",
      "download": "Stáhnout",
      "validate": "Validovat"
    },
    "preview": {
      "title": "JSON náhled",
      "copyRaw": "Kopírovat JSON",
      "copied": "Zkopírováno",
      "search": "Hledat v JSON",
      "matchCount": "{current} z {total}",
      "noMatches": "Nic nenalezeno",
      "expandAll": "Rozbalit vše",
      "collapseAll": "Sbalit vše"
    },
    "empty": {
      "title": "Žádné soubory",
      "description": "Zatím nebyly importovány žádné soubory ze SAPu."
    },
    "error": {
      "loadFailed": "Nepodařilo se načíst SAP soubory.",
      "previewFailed": "Nepodařilo se načíst náhled souboru.",
      "downloadFailed": "Nepodařilo se stáhnout soubor."
    },
    "validation": {
      "valid": "Soubor je validní",
      "modalTitle": "Validační chyby",
      "errorCount": "{count} chyb(a/y)",
      "field": "Pole",
      "errorCode": "Kód chyby",
      "errorMessage": "Zpráva",
      "notFound": "Soubor nenalezen",
      "unavailable": "Validace je momentálně nedostupná",
      "failed": "Validace selhala"
    }
  },
  "deadLetters": {
    "filters": {
      "messageType": "Typ zprávy",
      "exceptionType": "Typ výjimky",
      "exceptionMessage": "Text výjimky",
      "clear": "Vymazat filtry"
    },
    "table": {
      "showing": "Zobrazeno",
      "of": "z",
      "loading": "Načítání...",
      "messageType": "Typ zprávy",
      "exceptionType": "Výjimka",
      "exceptionMessage": "Text výjimky",
      "sentAt": "Odesláno",
      "replayable": "Opakovatelné",
      "actions": "Akce"
    },
    "actions": {
      "replay": "Opakovat",
      "delete": "Smazat",
      "clearSelection": "Zrušit výběr",
      "replayOne": "Opakovat tuto zprávu",
      "deleteOne": "Smazat tuto zprávu",
      "selected": "vybráno"
    },
    "confirm": {
      "replayTitle": "Opakovat zprávy",
      "replayMessage": "Opravdu chcete opakovat {count} zpráv(u/y)? Budou znovu zařazeny ke zpracování.",
      "deleteTitle": "Smazat zprávy",
      "deleteMessage": "Opravdu chcete trvale smazat {count} zpráv(u/y)? Tuto akci nelze vrátit zpět.",
      "deleteSingleMessage": "Opravdu chcete trvale smazat tuto zprávu? Tuto akci nelze vrátit zpět."
    },
    "notification": {
      "replayed": "Zprávy byly úspěšně zařazeny k opakování.",
      "deleted": "Zprávy byly úspěšně smazány.",
      "replayFailed": "Opakování zpráv se nezdařilo.",
      "deleteFailed": "Smazání zpráv se nezdařilo."
    },
    "empty": {
      "title": "Žádné nedoručené zprávy",
      "description": "Všechny zprávy jsou zpracovávány normálně."
    },
    "badge": {
      "yes": "Ano",
      "no": "Ne"
    }
  },
  "userMenu": {
    "settings": "Nastavení",
    "appearance": {
      "label": "Vzhled",
      "modes": {
        "light": "Světlý",
        "dark": "Tmavý"
      }
    },
    "auth": {
      "login": "Přihlásit se",
      "logout": "Odhlásit se",
      "notLoggedIn": "Nepřihlášen"
    }
  },
  "notification": {
    "quotationInformationNoChanges": "Nebyly nalezeny žádné změny",
    "quotationInformationSaveSuccessfully": "Informace o nabídce byly úspěšně uloženy",
    "quotationInformationSaveFailed": "Nepodařilo se uložit informace o nabídce",
    "deliveryInformationSaveSuccessfully": "Informace o dodání byly úspěšně uloženy",
    "deliveryInformationSaveFailed": "Nepodařilo se uložit informace o dodání",
    "handoverInformationSaveSuccessfully": "Informace o předání byly úspěšně uloženy",
    "handoverInformationSaveFailed": "Nepodařilo se uložit informace o předání",
    "quotationApprovedSuccessfully": "Nabídka byla schválena",
    "orderApprovedSuccessfully": "Objednávka byla schválena",
    "deliveryApprovedSuccessfully": "Dodání bylo schváleno",
    "quotationRejectedSuccessfully": "Nabídka byla odmítnuta",
    "orderRejectedSuccessfully": "Objednávka byla odmítnuta",
    "deliveryRejectedSuccessfully": "Dodání bylo zamítnuto",
    "changesSaveSuccessfully": "Změny byly úspěšně uloženy",
    "changesSaveFailed": "Nepodařilo se uložit změny",
    "requestedDeliveryDateValidationError": "Požadované datum dodání je povinné pole",
    "tyreDeliveryConfirmedSuccessfully": "Dodání pneumatik bylo potvrzeno",
    "notRegisteredUserApprovalLinkResent": "Odkaz ke schválení byl znovu odeslán {emails}",
    "notRegisteredUserApprovalLinkNoExpired": "Nebyly nalezeny žádné prošlé schvalovací odkazy k odeslání",
    "notRegisteredUserApprovalLinkResendFailed": "Nepodařilo se znovu odeslat odkaz ke schválení",
    "rejectFailed": "Nepodařilo se zamítnout workflow",
    "quotationRestartedSuccessfully": "Nabídka byla obnovena",
    "workflowUnparkedSuccessfully": "Workflow byl obnoven",
    "orderRestartedSuccessfully": "Objednávka byla obnovena",
    "deliveryRestartedSuccessfully": "Dodání bylo restartováno",
    "restartFailed": "Nepodařilo se obnovit workflow",
    "assignedToMeSuccessfully": "Případ převzat",
    "assignFailed": "Převzetí se nezdařilo"
  },
  "dashboard": {
    "searchPlaceholder": "Hledat dle ext. reference nebo popisu",
    "searchPlaceholderOrderNumber": "Hledat dle ext. reference nebo objednávky",
    "requiringAction": {
      "title": "Vyžaduje vaši akci",
      "viewAll": "Zobrazit vše",
      "client": "Klient",
      "supplier": "Dodavatel",
      "created": "Vytvořeno",
      "approveMessage": "Prosím, schvalte nebo odmítněte cenovou nabídku pro pokračování objednávky.",
      "openDetail": "Otevřít detail"
    },
    "empty": {
      "title": "Žádné přiřazené úkoly",
      "description": "Momentálně nemáte žádné workflow vyžadující vaši akci.",
      "viewAll": "Zobrazit všechny workflow"
    }
  },
  "workflows": {
    "bulkApprove": {
      "enter": "Hromadné schválení",
      "exit": "Ukončit hromadné schválení",
      "selected": "vybráno",
      "clearSelection": "Zrušit výběr",
      "approveSelected": "Schválit vybrané",
      "maxItems": "Najednou lze schválit nejvýše {max} nabídek.",
      "confirmTitle": "Hromadné schválení nabídek",
      "selectedReferences": "Vybrané nabídky",
      "progress": "Schvaluji {done} / {total}",
      "summaryTitle": "Výsledek hromadného schválení",
      "succeeded": "Schváleno: {count}",
      "failed": "Neúspěšné: {count}",
      "close": "Zavřít",
      "cancel": "Zrušit",
      "reason": {
        "notAssigned": "Nemáte oprávnění tuto nabídku schválit.",
        "stepChanged": "Nabídka mezitím opustila krok Schválení klientem.",
        "validation": "Nabídku nelze uložit, chybí povinná data.",
        "unknown": "Schválení se nezdařilo."
      }
    },
    "table": {
      "showing": "Zobrazeno",
      "of": "z",
      "loading": "Načítání...",
      "columns": {
        "externalReference": "Externí ref.",
        "status": "Stav",
        "delivery": "Dodání",
        "orderNumber": "Číslo objednávky",
        "client": "Klient",
        "driver": "Řidič",
        "description": "Popis",
        "supplier": "Dodavatel",
        "manufacturer": "Výrobce",
        "model": "Model",
        "vehicle": "Vozidlo",
        "assignees": "Přirazeno"
      },
      "filters": {
        "externalReference": "Filtr externí ref.",
        "status": "Filtr stavu",
        "client": "Filtr klienta",
        "driver": "Filtr řidiče",
        "description": "Filtr popisu",
        "orderNumber": "Filtr čísla objednávky",
        "supplier": "Filtr dodavatele",
        "manufacturer": "Filtr výrobce",
        "model": "Filtr modelu",
        "vehicle": "Filtr vozidla",
        "assignee": "Filtr přiřazeného",
        "assigneeUnavailable": "Filtrování podle přiřazeného je dočasně nedostupné, zkuste to prosím později.",
        "dateRange": "Vyberte časové období",
        "clearDateFilter": "Vymazat filtr data",
        "clear": "Zrušit filtry"
      },
      "dateFilters": {
        "allDates": "Všechna data",
        "today": "Dnes",
        "thisWeek": "Tento týden",
        "thisMonth": "Tento měsíc",
        "thisYear": "Tento rok",
        "customRange": "Vlastní období"
      },
      "multipleSuppliers": "Více dodavatelů",
      "multipleOrders": "Více objednávek"
    },
    "assignedFilter": {
      "allWorkflows": "Všechny workflow",
      "assignedToMe": "Přiřazené mně"
    }
  },
  "workflowDetail": {
    "header": {
      "detail": "Detail",
      "objectNumber": "Číslo objektu",
      "purchaseOrderNumber": "Číslo objednávky",
      "calculationNumber": "Číslo kalkulace",
      "quotationNumber": "Číslo nabídky",
      "updatedVersionTooltip": "Aktualizovaná verze (v{version})",
      "downloadCalculation": "Stáhnout kalkulaci",
      "downloadPurchaseOrder": "Stáhnout objednávku",
      "pdf": "PDF",
      "registrationProxy": "PDF",
      "downloadRegistrationProxy": "Stáhnout proxy pro registraci",
      "pdfNotFound": "Dokument nebyl nalezen.",
      "pdfDownloadError": "Stažení dokumentu se nezdařilo.",
      "reject": "Zamítnout",
      "restart": "Restart",
      "assignMe": "Převzít",
      "viewQuotationData": "Zobrazit původní data z nabídky"
    },
    "actions": {
      "cancel": "Zrušit",
      "save": "Uložit",
      "edit": "Upravit",
      "unsavedChangesTitle": "Neuložené změny",
      "unsavedChangesMessage": "Máte neuložené změny. Chcete je zahodit?",
      "discard": "Zahodit",
      "continueEditing": "Pokračovat v úpravách"
    },
    "common": {
      "yes": "Ano",
      "no": "Ne",
      "select": "Vybrat",
      "exclVat": "bez DPH",
      "inclVat": "vč. DPH",
      "months": "Měsíce",
      "annual": "Roční",
      "total": "Celkem"
    },
    "tabs": {
      "overview": "Přehled",
      "additionalInformation": "Doplňující informace",
      "documents": "Dokumenty",
      "notes": "Poznámky",
      "eventHistory": "Historie událostí"
    },
    "overview": {
      "investmentPrice": "Investiční cena",
      "monthlyPayment": "Měsíční splátka",
      "contractSectionTitle": "Smlouva a dodání",
      "tyreSectionTitle": "Pneumatiky",
      "vehicleSectionTitle": "Vozidlo"
    },
    "meaningDeliveryDate": {
      "asap": "Co nejdříve",
      "onDate": "K datu (EQ)",
      "afterDate": "Po datu (GE)",
      "beforeDate": "Před datem (LE)"
    },
    "vehicle": {
      "vin": "VIN",
      "make": "Značka",
      "makeName": "Název",
      "code": "Kód",
      "model": "Model",
      "modelName": "Název",
      "enginePower": "Výkon motoru",
      "upholstery": "Interiér",
      "color": "Barva",
      "material": "Materiál",
      "homologation": "Homologace",
      "wheelCount": "Počet kol",
      "seats": "Počet sedadel",
      "co2Emissions": "Emise CO₂",
      "category": "Kategorie",
      "exterior": "Exteriér"
    },
    "tyreSpec": {
      "title": "Specifikace pneumatik",
      "dimensions": "Rozměry",
      "type": "Typ",
      "width": "Šířka",
      "profile": "Profil",
      "diameter": "Průměr",
      "speedIndex": "Index rychlosti",
      "loadIndex": "Index nosnosti",
      "rimSensor": "RIM senzor (TPMS)",
      "quantity": "Množství",
      "pcs": "ks",
      "pricing": "Cena",
      "listPrice": "Ceníková cena",
      "discount": "Sleva",
      "netPrice": "Cena po slevě",
      "perPiece": "za kus",
      "total": "Celkem",
      "typeSummer": "Letní",
      "typeWinter": "Zimní",
      "typeWinterStudded": "Zimní s hroty",
      "typeAllSeason": "Celoroční"
    },
    "tyrePackage": {
      "title": "Sada pneumatik",
      "priceAfterDiscount": "Cena po slevě",
      "total": "Celkem",
      "discount": "Sleva",
      "tyresTitle": "Pneumatiky",
      "rimsTitle": "Disky",
      "tpmsTitle": "Snímače tlaku (TPMS)",
      "description": "Popis",
      "dimensions": "Rozměry",
      "diameter": "Průměr",
      "type": "Typ",
      "brand": "Značka",
      "quantity": "Ks",
      "code": "Kód"
    },
    "contract": {
      "product": "Produkt",
      "financialProduct": "Finanční produkt",
      "commercialProduct": "Komerční produkt",
      "duration": "Doba",
      "mileage": "Nájezd",
      "externalReference": "Externí reference",
      "createdDate": "Datum vytvoření",
      "quotationValidTo": "Datum platnosti",
      "requestForRegistration": "Žádost o registraci",
      "firstRegistrationDate": "Datum 1. registrace",
      "handoverRequestSend": "Odeslání výzvy k převzetí",
      "dealerExpectedDeliveryDate": "Předpokládané datum dodání",
      "meaningOfReqDeliveryDate": "Upřesnění požad. data dodání",
      "requiredDeliveryDate": "Požadované datum dodání",
      "possibleDeliveryDate": "Možné datum dodání",
      "registrationNumber": "Registrační značka",
      "dealerOrderId": "ID objednávky dealera",
      "initialQuotationNumber": "Č. cenové nabídky dealera",
      "handoverDate": "Datum předání",
      "registrationDate": "Datum registrace",
      "handoverMileage": "Stav km při předání",
      "initialMileage": "Počáteční stav km",
      "stockDealer": "Sklad dealera",
      "arrivedAtDealer": "Dodáno k dealerovi",
      "poolCar": "Pool car",
      "replacedCarRegNumber": "RZ nahrazovaného vozu",
      "replacedCarContractEnd": "Konec smlouvy nahr. vozu",
      "secondTyreSetStorageAddress": "Místo uložení pneumatik",
      "secondTyreSetStorageDate": "Datum uložení pneumatik"
    },
    "driver": {
      "title": "Řidič",
      "id": "ID",
      "name": "Jméno",
      "phone": "Telefon",
      "email": "E-mail",
      "staffId": "Osobní číslo",
      "selectDriver": "Vybrat řidiče",
      "serviceUnavailable": "Služba nedostupná",
      "carBenefitLevel": "Úroveň car benefitu",
      "fullBenefitValue": "Plná hodnota benefitu",
      "limitedBenefitValue": "Omezená hodnota benefitu",
      "benefitLevels": {
        "limited": "Omezený benefit",
        "full": "Plný benefit"
      }
    },
    "contactForVehicle": {
      "title": "Kontakt pro vozidlo",
      "id": "ID",
      "name": "Jméno",
      "phone": "Telefon",
      "email": "E-mail",
      "serviceUnavailable": "Služba nedostupná"
    },
    "client": {
      "title": "Klient",
      "name": "Jméno",
      "id": "ID",
      "contractNumber": "Číslo smlouvy",
      "costCentreNumber": "Číslo nákladového střediska",
      "costCentre": "Nákladové středisko",
      "serviceUnavailable": "Služba nedostupná"
    },
    "supplier": {
      "title": "Dodavatel",
      "name": "Jméno",
      "id": "ID",
      "address": "Adresa",
      "email": "E-mail",
      "phone": "Telefon",
      "salesPerson": "Prodejce",
      "usingEOrders": "Používá eOrders",
      "notUsingEOrders": "Nepoužívá eOrders",
      "addEmailAddress": "Přidat e-mailovou adresu"
    },
    "purchaseOrderType": {
      "vehicle": "Vozidlo",
      "tyre": "Pneumatiky"
    }
  },
  "additionalInfo": {
    "fuelCards": {
      "title": "Palivové karty",
      "cardType": "Typ karty",
      "orderConfirmed": "Objednávka potvrzena",
      "validFrom": "Platné od",
      "deliveryDate": "Datum dodání",
      "status": "Stav",
      "noCardsAvailable": "Žádné palivové karty nejsou k dispozici"
    },
    "services": {
      "title": "Služby",
      "serviceCode": "Kód služby",
      "serviceName": "Název služby",
      "specification": "Specifikace",
      "included": "Včetně",
      "monthlyRate": "Měsíční sazba (bez DPH)",
      "noServicesAvailable": "Žádné služby nejsou k dispozici"
    },
    "vehicle": {
      "title": "Vozidlo",
      "description": "Popis vozidla",
      "deliveryCost": "Náklady na doručení",
      "registrationTax": "Registrační daň vozidla",
      "registrationCost": "Registrační poplatek"
    },
    "accessories": {
      "title": "Doplňky a výbava",
      "titleAccessoriesOnly": "Doplňky",
      "seqNumber": "Č.",
      "code": "Kód",
      "description": "Popis doplňku",
      "standard": "Standard",
      "manufacturer": "Výrobce",
      "price": "Cena",
      "afterDiscount": "Po slevě (bez DPH)",
      "discount": "Sleva",
      "owner": "Vlastník",
      "noAccessoriesAvailable": "Žádné doplňky nejsou k dispozici"
    },
    "options": {
      "title": "Výbava",
      "description": "Popis výbavy",
      "total": "Výbava celkem",
      "registrationTax": "Registrační daň za výbavu",
      "noOptionsAvailable": "Žádná výbava není k dispozici"
    },
    "tyres": {
      "title": "Pneumatiky",
      "position": "Pozice",
      "manufacturer": "Výrobce",
      "dimensions": "Rozměry",
      "loadIndex": "Nosnost",
      "speedIndex": "Rychlostní index",
      "season": "Sezóna",
      "price": "Cena",
      "noTyresAvailable": "Žádné pneumatiky nejsou k dispozici"
    },
    "mileageRates": {
      "title": "Kilometrové sazby",
      "baseRate": "Základní sazba",
      "mvaLess": "Podlimitní kilometry",
      "mvaMore": "Nadlimitní kilometry",
      "noMileageRatesAvailable": "Žádné kilometrové sazby k dispozici"
    }
  },
  "processStatus": {
    "categories": {
      "statusWithStep": "Stav - krok",
      "statusOnly": "Pouze stav"
    },
    "status": {
      "quotationApproval": "Schválení nabídky",
      "orderApproval": "Schválení objednávky",
      "orderProcessing": "Zpracování objednávky",
      "orderUpdated": "Objednávka aktualizována",
      "delivery": "Dodání",
      "quotationRejection": "Zamítnutí nabídky",
      "orderRejection": "Zamítnutí objednávky",
      "deliveryRejection": "Zamítnutí dodání",
      "rejected": "Zamítnuto",
      "completed": "Dokončeno",
      "archived": "Archivováno"
    },
    "step": {
      "quotationApproval": {
        "notDefined": "Nedefinováno",
        "schemaFinalization": "Finalizace schématu",
        "parked": "Pozastaveno",
        "driverApproval": "Ke schválení řidičem",
        "clientApproval": "Ke schválení klientem",
        "hRApproval": "Ke schválení HR",
        "fleetManagerApproval": "Ke schválení FleetManager",
        "supervisorApproval": "Ke schválení nadřízeným",
        "groupApproval": "Ke schválení skupinou",
        "personApproval": "Ke schválení osobou",
        "notRegisteredUserApproval": "Ke schválení neregistrovaným uživatelem",
        "purchaseSupportApproval": "Ke schválení Purchase Support",
        "clientAccountAcceptation": "Ke schválení CA",
        "orderCreation": "Vytvoření objednávky",
        "completed": "Dokončeno"
      },
      "quotationRejection": {
        "rejection": "K zamítnutí",
        "rejected": "Zamítnuto"
      },
      "delivery": {
        "parked": "Pozastaveno",
        "notDefined": "Nedefinováno",
        "notActive": "Neaktivní",
        "waiting": "Čeká",
        "vehicleRegistration": "Registrace vozidla",
        "handoverPreparation": "Příprava předání",
        "handover": "K předání",
        "delivered": "Doručeno",
        "completed": "Dokončeno",
        "rejection": "Odmítnutí",
        "rejected": "Zamítnuto"
      },
      "deliveryRejection": {
        "rejection": "Odmítnutí",
        "rejected": "Zamítnuto",
        "parked": "Pozastaveno"
      },
      "orderApproval": {
        "parked": "Pozastaveno",
        "kamApproval": "Schválení KAM",
        "oDApproval": "Schválení OD",
        "deliveryConfirmation": "Potvrzení dodání",
        "supplierAcceptation": "Přijetí dodavatelem",
        "supplierApproval": "Schválení dodavatelem",
        "dealerAcceptation": "Přijetí dealerem",
        "dealerConfirmation": "Potvrzení dealerem",
        "dealerRejectionConfirmation": "Potvrzení odmítnutí dealerem",
        "dealerRejection": "Zamítnuto dealerem",
        "delivered": "Doručeno",
        "notDefined": "Nedefinováno",
        "rejection": "Odmítnutí",
        "rejected": "Zamítnuto",
        "completed": "Dokončeno"
      },
      "orderProcessing": {
        "parked": "Pozastaveno",
        "waiting": "Čeká",
        "supplierAcceptation": "Přijetí dodavatelem",
        "deliveryConfirmation": "Potvrzení dodání",
        "delivered": "Doručeno",
        "completed": "Dokončeno"
      },
      "orderUpdated": {
        "parked": "Pozastaveno",
        "waiting": "Čeká",
        "completed": "Dokončeno"
      },
      "orderRejection": {
        "notDefined": "Nedefinováno",
        "dealerRejection": "Zamítnuto ze strany dealera",
        "dealerRejectionConfirmation": "Potvrzení odmítnutí dealerem",
        "supplierAcceptation": "Přijetí dodavatelem",
        "supplierApproval": "Schválení dodavatelem",
        "rejection": "Odmítnutí",
        "rejected": "Zamítnuto"
      },
      "completed": {
        "delivered": "Doručeno",
        "completed": "Dokončeno"
      },
      "rejected": {
        "rejected": "Zamítnuto",
        "rejection": "Odmítnutí",
        "dealerRejection": "Zamítnuto ze strany dealera",
        "dealerRejectionConfirmation": "Potvrzení odmítnutí dealerem"
      }
    },
    "combined": {
      "quotationSchemaFinalization": "Nabídka - Finalizace schématu",
      "quotationParked": "Nabídka - Pozastaveno",
      "orderApprovalParked": "Objednávka - Pozastaveno",
      "orderProcessingParked": "Zpracování objednávky - Pozastaveno",
      "orderUpdatedParked": "Aktualizovaná objednávka - Pozastaveno",
      "deliveryParked": "Dodání - Pozastaveno",
      "quotationApprovals": "Nabídka - Schvalování",
      "quotationClientApproval": "Nabídka - Schválení klientem",
      "quotationClientAccountAcceptation": "Nabídka - Schválení CA",
      "quotationOrderCreation": "Nabídka - Vytvoření objednávky",
      "orderKamApproval": "Objednávka - Schválení KAM",
      "orderOdApproval": "Objednávka - Schválení OD",
      "orderDealerAcceptation": "Objednávka - Přijetí dealerem",
      "orderDealerConfirmation": "Objednávka - Potvrzení dealerem",
      "orderProcessingWaiting": "Zpracování objednávky - Čeká",
      "orderUpdatedWaiting": "Objednávka aktualizována - Čeká",
      "deliveryVehicleRegistration": "Dodání - Registrace vozidla",
      "deliveryHandoverPreparation": "Dodání - Příprava předání",
      "deliveryHandover": "Dodání - K předání",
      "tyreSupplierApproval": "Pneumatiky - Schválení dodavatelem",
      "tyreSupplierAcceptation": "Pneumatiky - Přijetí dodavatelem",
      "tyreDeliveryConfirmation": "Pneumatiky - Potvrzení dodání",
      "tyreDelivered": "Pneumatiky - Doručeno"
    },
    "actions": {
      "approve": "Schválit",
      "acceptOrder": "Přijmout objednávku",
      "confirmOrder": "Potvrdit objednávku",
      "approveAndConfirm": "Schválit a potvrdit",
      "reject": "Zamítnout",
      "submit": "Potvrdit",
      "save": "Uložit",
      "close": "Zavřít"
    },
    "manageApprovalFlow": "Spravovat schvalovací proces",
    "rejectReasonLabel": "Uveďte prosím důvod odmítnutí",
    "rejectReasonPlaceholder": "Napište důvod...",
    "rejectReasonRequired": "Důvod odmítnutí je povinný",
    "actionRequiredQuotationSchemaFinalization": "Vyžadováno potvrzení: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationParked": "Tento workflow je pozastaven. Zvolte způsob obnovení.",
    "actionRequiredQuotationParkedWithOrders": "Workflow pozastaven. Zvolte obnovení - poté rozhodnete u každé objednávky.",
    "actionRequiredOrderParked": "Původní objednávka je pozastavená. Zvolte, jak s ní naložit.",
    "orderUnpark": {
      "restart": "Restartovat novou verzi objednávky",
      "noRestart": "Pokračovat bez nové aktualizované objednávky"
    },
    "unpark": {
      "restartFromQuotation": "Vrátit klientovi",
      "restartFromPurchaseOrder": "Vrátit dealerovi",
      "noRestart": "Pokračovat bez schválení"
    },
    "actionRequiredQuotationDriverApproval": "Vyžadováno potvrzení: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationHRApproval": "Vyžadováno potvrzení: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationFleetManagerApproval": "Vyžadována akce: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationClientApproval": "Vyžadováno potvrzení: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationSupervisorApproval": "Vyžadováno potvrzení: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationGroupApproval": "Vyžadováno potvrzení: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationPersonApproval": "Vyžadováno potvrzení: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationPurchaseSupportApproval": "Vyžadováno potvrzení: schvalte či zamítněte nabídku pro další postup objednávky.",
    "actionRequiredQuotationClientAdjustment": "Vyžadována akce: Vyplňte a zkontrolujte pole níže. Po vyplnění může nabídku schválit ClientAccount.",
    "actionRequiredQuotationClientAccountAcceptation": "Vyžadováno potvrzení: doplňte č. cenové nabídky a poté ji schvalte nebo zamítněte.",
    "actionRequiredQuotationRejection": "Vyžadována akce: Nabídka byla zamítnuta. Potvrďte prosím pro finalizaci zamítnutí.",
    "actionRequiredDeliveryStepRejection": "Vyžadována akce: Dodání bylo zamítnuto. Potvrďte prosím dokončení zamítnutí.",
    "actionRequiredVehicleOrderStepKamApproval": "Vyžadována akce: Schvalte nebo zamítněte objednávku pro další postup.",
    "actionRequiredVehicleOrderStepODApproval": "Vyžadována akce: Zkontrolujte dodavatele a poté schvalte nebo zamítněte objednávku pro další postup.",
    "actionRequiredVehicleOrderStepDealerAcceptation": "Vyžadována akce: Schvalte nebo zamítněte objednávku pro další postup.",
    "actionRequiredVehicleOrderStepDealerConfirmation": "Vyžadována akce: Vyplňte předpokládané datum dodání a schvalte nebo zamítněte objednávku.",
    "actionRequiredVehicleOrderStepDealerRejectionConfirmation": "Vyžadována akce: Potvrďte zamítnutí objednávky.",
    "actionRequiredVehicleOrderStepDealerRejection": "Vyžadována akce: Dealer zamítl tuto objednávku. Potvrďte prosím pro finalizaci zamítnutí.",
    "actionRequiredDeliveryStepWaiting": "Vyžadována akce: Vyplňte prosím všechny potřebné položky níže.",
    "actionRequiredDeliveryStepVehicleRegistration": "Vyžadována akce: Zkontrolujte nebo doplňte registrační značku a datum registrace.",
    "actionRequiredDeliveryStepHandoverPreparation": "Vyžadována akce: Potvrďte, že bylo odesláno oznámení o předání vozidla.",
    "actionRequiredDeliveryStepHandover": "Vyžadována akce: Zadejte nebo potvrďte datum a stav kilometrů při předání vozidla.",
    "selectDriver": "Vyberte řidiče",
    "dontKnowDriver": "Neznám řidiče",
    "knowDriver": "Znám řidiče",
    "driverFirstName": "Jméno",
    "driverLastName": "Příjmení",
    "driverPhone": "Telefon",
    "driverEmail": "E-mail",
    "driverFilledByClient": "Řidič vyplněn klientem",
    "replacedCarRegNumber": "RZ nahrazovaného vozu",
    "meaningOfReqDeliveryDate": "Upřesnění požad. data dodání",
    "requiredDeliveryDate": "Požadované datum dodání",
    "possibleDeliveryDate": "Možné datum dodání",
    "vin": "VIN",
    "co2Emissions": "Emise CO₂",
    "registrationNumber": "Registrační značka",
    "registrationDate": "Datum registrace",
    "socialSecurityNumber": "Rodné číslo",
    "initialQuotationNumber": "Č. cenové nabídky dealera",
    "dealerExpectedDeliveryDate": "Předpokládané datum dodání",
    "expectedDeliveryDateInvalidTitle": "Neplatné předpokládané datum dodání.",
    "expectedDeliveryDateInvalidMessage": "Předpokládané datum dodání musí být vyšší než možné datum dodání a minimálně sedm pracovních dnů od dneška.",
    "registrationDateMustBeTodayMessage": "Datum registrace musí odpovídat dnešnímu datu.",
    "handoverDate": "Datum předání",
    "handoverMileage": "Stav km při předání",
    "initialMileage": "Počáteční stav km",
    "actionRequiredTyreOrderStepSupplierApproval": "Vyžadována akce: Schvalte nebo zamítněte objednávku pneumatik pro pokračování.",
    "actionRequiredTyreOrderStepSupplierAcceptation": "Vyžadována akce: Schvalte nebo zamítněte objednávku pneumatik pro pokračování.",
    "actionRequiredTyreOrderStepDeliveryConfirmation": "Vyžadována akce: Potvrďte dodání a případně zadejte informace o doručení druhé sady pneumatik.",
    "actionRequiredTyreOrderStepRejection": "Vyžadována akce: Dodavatel zamítl tuto objednávku pneumatik. Potvrďte prosím pro finalizaci zamítnutí.",
    "secondTyreSetDeliveryInfo": "Uveďte zde, kam byla doručena druhá sada pneumatik",
    "secondTyreSetDeliveryDate": "Datum doručení",
    "actionRequiredQuotationNotRegisteredUserApproval": "Vyžadována akce: Schvalte nebo zamítněte nabídku pro pokračování s objednávkou.",
    "resendNotRegisteredUserApprovalLink": "Znovu odeslat odkaz"
  },
  "workflow": {
    "approval": {
      "title": "Schvalovací proces workflow",
      "description": "Spravujte schvalovací kroky pro tento workflow",
      "workflowId": "ID workflow",
      "loading": "Načítání schvalovacího procesu...",
      "addStep": "Přidat krok",
      "stepTypePlaceholder": "Vyberte typ kroku",
      "step": "Krok",
      "supervisorEmail": "E-mail nadřízeného",
      "notRegisteredUserEmail": "E-mail neregistrovaného uživatele",
      "notRegisteredUserEmailRequired": "Zadejte prosím e-mailovou adresu pro tento krok.",
      "supervisorEmailRequired": "Zadejte prosím e-mailovou adresu nadřízeného pro tento krok.",
      "personPlaceholder": "Vyberte osobu...",
      "personRequired": "Vyberte uživatele pro tento krok.",
      "noEmployeesFound": "Pro tohoto klienta nebyli nalezeni žádní registrovaní zaměstnanci.",
      "groupPlaceholder": "Vyberte cestu skupiny...",
      "groupRequired": "Vyberte cestu skupiny pro tento krok.",
      "stepTypeRequired": "Pro pokračování vyberte typ pro každý krok.",
      "empty": "Nejsou definovány žádné vlastní schvalovací kroky. Po uložení bude použit výchozí krok Schválení podporou nákupu.",
      "addFirstStep": "Přidat vlastní krok",
      "saveWorkflowAndClient": "Uložit a nastavit jako výchozí pro klienta",
      "saveWorkflowAndClientShort": "Uložit & výchozí",
      "save": "Uložit pro tuto nabídku",
      "saveShort": "Uložit",
      "close": "Zavřít",
      "error": "Nelze načíst schvalovací proces workflow.",
      "saveSuccess": "Schvalovací proces byl úspěšně uložen.",
      "saveError": "Nelze uložit schvalovací proces.",
      "clientSaveSuccess": "Schvalovací proces klienta byl úspěšně uložen.",
      "clientSaveError": "Schvalovací proces pro klienta se nepodařilo uložit.",
      "stepTypes": {
        "driverApprovalStep": "Schválení řidičem",
        "hrApprovalStep": "Schválení HR",
        "fleetManagerApprovalStep": "Schválení fleet manažerem",
        "purchaseSupportApprovalStep": "Schválení podporou nákupu",
        "supervisorApprovalStep": "Schválení nadřízeným",
        "notRegisteredUserApprovalStep": "Schválení neregistrovaným uživatelem",
        "groupApprovalStep": "Schválení skupinou",
        "personApprovalStep": "Schválení osobou"
      }
    }
  },
  "notes": {
    "addNewNote": "Přidat novou poznámku",
    "placeholderText": "Napište svou poznámku...",
    "submitNote": "Odeslat poznámku",
    "noNotesYet": "Zatím žádné poznámky",
    "noteAddedSuccessfully": "Poznámka byla úspěšně přidána",
    "failedToAddNote": "Nepodařilo se přidat poznámku"
  },
  "clients": {
    "table": {
      "showing": "Zobrazeno",
      "of": "z",
      "loading": "Načítání...",
      "columns": {
        "id": "ID",
        "name": "Název"
      },
      "search": {
        "global": "Hledat podle ID nebo názvu klienta"
      }
    },
    "detail": {
      "title": "Detail klienta",
      "description": "Přehled schvalovacího procesu",
      "clientId": "ID klienta",
      "loading": "Načítání schvalovacího procesu...",
      "addStep": "Přidat krok",
      "stepTypePlaceholder": "Vyberte typ kroku",
      "step": "Krok",
      "supervisorEmail": "Email nadřízeného",
      "notRegisteredUserEmail": "E-mail neregistrovaného uživatele",
      "personPlaceholder": "Vyberte osobu...",
      "personRequired": "Vyberte uživatele pro tento krok.",
      "noEmployeesFound": "Pro tohoto klienta nebyli nalezeni žádní registrovaní zaměstnanci.",
      "groupPlaceholder": "Vyberte cestu skupiny...",
      "groupRequired": "Vyberte cestu skupiny pro tento krok.",
      "stepTypeRequired": "Pro pokračování vyberte typ pro každý krok.",
      "empty": "Nejsou definovány žádné vlastní schvalovací kroky. Po uložení bude použit výchozí krok Schválení podporou nákupu.",
      "createFlow": "Vytvořit vlastní proces",
      "addFirstStep": "Přidat vlastní krok",
      "applyDefaultFlow": "Použít výchozí schvalovací proces",
      "save": "Uložit",
      "close": "Zavřít",
      "order": "Pořadí",
      "role": "Role",
      "group": "Skupina",
      "error": "Nelze načíst detail klienta.",
      "stepDescriptionFallback": "Vlastní schvalovací krok",
      "defaultApplied": "Výchozí schvalovací proces byl použit.",
      "defaultApplyError": "Nelze použít výchozí schvalovací proces.",
      "customFlowCreated": "Vlastní schvalovací proces byl vytvořen.",
      "customFlowCreateError": "Nelze vytvořit nový schvalovací proces.",
      "saveSuccess": "Schvalovací proces byl úspěšně uložen.",
      "saveError": "Nelze uložit schvalovací proces.",
      "stepTypes": {
        "driverApprovalStep": "Schválení řidičem",
        "hrApprovalStep": "Schválení HR",
        "fleetManagerApprovalStep": "Schválení fleet manažerem",
        "purchaseSupportApprovalStep": "Schválení podporou nákupu",
        "supervisorApprovalStep": "Schválení nadřízeným",
        "notRegisteredUserApprovalStep": "Schválení neregistrovaným uživatelem",
        "groupApprovalStep": "Schválení skupinou",
        "personApprovalStep": "Schválení osobou"
      },
      "notice": {
        "custom": "Tento klient používá vlastní schvalovací proces.",
        "default": "Tento klient aktuálně používá výchozí schvalovací proces (Purchase Support Approval).",
        "empty": "Vlastní schvalovací proces je prázdný. Po uložení bude automaticky použit výchozí krok Schválení podporou nákupu (PurchaseSupport Approval)."
      }
    }
  },
  "documents": {
    "noDocumentsFound": "Žádné dokumenty nenalezeny",
    "uploadHint": "Můžete nahrát dokument.",
    "uploadSuccess": "Soubor(y) úspěšně nahrán(y)",
    "uploadError": "Nahrávání souboru(ů) se nezdařilo",
    "downloadError": "Stažení souboru se nezdařilo"
  },
  "fileUpload": {
    "dragAndDrop": "Přetáhněte soubory nebo <span class=\"text-primary\">klikněte pro výběr</span>",
    "upload": "Nahrát {count} soubor(ů)",
    "removeFile": "Odstranit soubor",
    "maxFilesExceeded": "Nelze vybrat více než {max} souborů najednou.",
    "fileSizeHint": "Maximální velikost jednoho souboru je {maxSize}&nbsp;MB. Povolené typy: {allowedTypes}.",
    "fileSizeExceeded": "Soubor {fileName} přesahuje maximální velikost {maxSize} MB.",
    "fileTypeNotSupported": "Soubor {fileName} má nepodporovaný typ. Povolené typy: {allowedTypes}."
  },
  "eventHistory": {
    "noRecords": "Nebyly nalezeny žádné záznamy historie"
  },
  "workflowPublic": {
    "protectedAccess": "Chráněný přístup",
    "description": "Tento detail workflow je chráněn heslem.",
    "requestCodeDescription": "Pro zobrazení tohoto workflow si vyžádejte přístupový kód. Bude odeslán na e-mailovou adresu spojenou s tímto workflow.",
    "sendAccessCode": "Odeslat přístupový kód",
    "enterCode": "Zadejte kód",
    "codeSentDescription": "Zadejte prosím 6místný kód zaslaný na váš e-mail.",
    "verifyAccess": "Ověřit přístup",
    "resendCode": "Odeslat kód znovu",
    "resendIn": "Odeslat znovu za {seconds}s",
    "resendLimitReached": "Dosažen maximální počet pokusů o odeslání",
    "codeSent": "Přístupový kód byl odeslán na váš e-mail",
    "codeResent": "Nový přístupový kód byl odeslán na váš e-mail",
    "verified": "Úspěšně ověřeno",
    "approved": "Schválení bylo úspěšně odesláno",
    "retryIn": "Zkuste to znovu za {minutes} minut",
    "tryAgain": "Zkusit znovu",
    "errors": {
      "expired": "Tento odkaz pro schválení vypršel. Požádejte o nový.",
      "invalidCode": "Zadaný kód je neplatný nebo již vypršel. Nechte si prosím zaslat nový kód.",
      "rateLimited": "Příliš mnoho pokusů. Počkejte prosím a zkuste to znovu.",
      "sessionExpired": "Vaše relace vypršela. Začněte prosím znovu.",
      "forbidden": "Nemáte oprávnění k provedení této akce.",
      "serverError": "Něco se pokazilo. Zkuste to prosím znovu později."
    },
    "errorTitles": {
      "expired": "Odkaz vypršel",
      "invalidCode": "Neplatný nebo vypršelý kód",
      "rateLimited": "Příliš mnoho pokusů",
      "unauthorized": "Relace vypršela",
      "serverError": "Chyba serveru"
    }
  },
  "rejectModal": {
    "title": "Zamítnutí workflow",
    "reasonLabel": "Důvod zamítnutí",
    "deliveryMessage": "Tímto zamítnete dodání. Následně můžete zamítnutí potvrdit, nebo dodání vrátit.",
    "reasonPlaceholder": "Uveďte důvod zamítnutí...",
    "initiatorLabel": "Iniciátor zamítnutí",
    "initiatorPlaceholder": "Vyberte, kdo inicioval zamítnutí...",
    "initiatorSupplier": "Dodavatel",
    "initiatorClient": "Klient",
    "cancel": "Zrušit",
    "confirm": "Zamítnout"
  },
  "noAccess": {
    "title": "Přístup odepřen",
    "description": "Nemáte oprávnění k zobrazení této stránky. Pokud si myslíte, že se jedná o chybu, kontaktujte svého administrátora.",
    "backHome": "Zpět na úvod"
  },
  "error": {
    "loadingData": "Nepodařilo se načíst data.",
    "apiDown": "Server neodpovídá. Zkuste to prosím později."
  }
}